import { c as _c } from "react/compiler-runtime";
import { FormInput, InputProps, Modal, PrimaryButton, toast } from '@systemeio/ui';
import { BadRequest } from '@systemeio/util';
import { InternalError } from '@systemeio/util';
import { createSenderEmailAddress } from 'modules/profile/mailing-settings/api/mailing-settings-sender-emails-api';
import { MailingSettingsSenderEmailAddressErrors } from 'modules/profile/mailing-settings/types/sender-email-address-interface';
import React, { useEffect, useState } from 'react';
import { isClient } from 'shared/components/screen-height-div';
import { useLocoTranslation } from 'shared/hooks/use-loco-translation';
import { UpdateDataFunctionType } from 'shared/hooks/use-update-data';
const defaultErrors: MailingSettingsSenderEmailAddressErrors = {
  email: '',
  common: []
};
function CreateSenderEmailAddressModal(t0) {
  const $ = _c(50);
  const {
    updateSenderEmailsAddressesTable,
    withoutButton,
    value,
    error,
    wrapperRef
  } = t0;
  const {
    t
  } = useLocoTranslation();
  const [opened, setOpened] = useState(false);
  const t1 = value || "";
  let t2;
  if ($[0] !== t1) {
    t2 = {
      email: t1
    };
    $[0] = t1;
    $[1] = t2;
  } else {
    t2 = $[1];
  }
  const [tempState, setTempState] = useState(t2);
  const [isFetching, setIsFetching] = useState(false);
  const [errors, setErrors] = useState(defaultErrors);
  let t3;
  let t4;
  if ($[2] !== value) {
    t3 = () => {
      if (value) {
        setTempState({
          email: value
        });
      }
    };
    t4 = [value];
    $[2] = value;
    $[3] = t3;
    $[4] = t4;
  } else {
    t3 = $[3];
    t4 = $[4];
  }
  useEffect(t3, t4);
  let t5;
  if ($[5] !== wrapperRef) {
    t5 = () => {
      const confirmButton = isClient() ? wrapperRef?.current?.querySelector("#js-confirm-email-button") : null;
      const onClick = () => {
        setOpened(true);
      };
      if (confirmButton) {
        confirmButton.className = "text-brand-primary hover:text-brand-primary-hover outline-hidden focus-visible:text-brand-primary-hover main-transition-color contents";
        confirmButton.addEventListener("click", onClick);
        confirmButton.type = "button";
      }
      return () => confirmButton?.removeEventListener("click", onClick);
    };
    $[5] = wrapperRef;
    $[6] = t5;
  } else {
    t5 = $[6];
  }
  let t6;
  if ($[7] !== error || $[8] !== wrapperRef) {
    t6 = [error, wrapperRef];
    $[7] = error;
    $[8] = wrapperRef;
    $[9] = t6;
  } else {
    t6 = $[9];
  }
  useEffect(t5, t6);
  let t7;
  if ($[10] === Symbol.for("react.memo_cache_sentinel")) {
    t7 = () => {
      setOpened(false);
    };
    $[10] = t7;
  } else {
    t7 = $[10];
  }
  const onClose = t7;
  let t8;
  if ($[11] !== t || $[12] !== tempState || $[13] !== updateSenderEmailsAddressesTable) {
    t8 = async () => {
      ;
      try {
        setIsFetching(true);
        setErrors(defaultErrors);
        await createSenderEmailAddress(tempState);
        if (updateSenderEmailsAddressesTable) {
          await updateSenderEmailsAddressesTable();
        }
        onClose();
        toast.success(t("dashboard.settings.mailing.sender_email_added_title"));
      } catch (t9) {
        const e = t9;
        setIsFetching(false);
        if (e instanceof BadRequest) {
          setErrors({
            email: e.errors.fields.email?.join(""),
            common: e.errors.common
          });
        } else {
          if (e instanceof InternalError) {
            setErrors(t("core.error.internal_error_message"));
          }
        }
        toast.error(t("global.error"));
      }
    };
    $[11] = t;
    $[12] = tempState;
    $[13] = updateSenderEmailsAddressesTable;
    $[14] = t8;
  } else {
    t8 = $[14];
  }
  const handleConfirm = t8;
  let t9;
  if ($[15] !== t || $[16] !== withoutButton) {
    t9 = !withoutButton && <div className="[&>svg]:fill-brand-primary [&>svg]:main-transition-colors flex items-center gap-3 px-6 py-6"><div className="text-brand-primary cursor-pointer" onClick={() => setOpened(true)}>{t("dashboard.settings.mailing.sender_email.create_button.title")}</div></div>;
    $[15] = t;
    $[16] = withoutButton;
    $[17] = t9;
  } else {
    t9 = $[17];
  }
  let t10;
  if ($[18] !== t) {
    t10 = t("dashboard.settings.mailing.sender_email.create_modal.title");
    $[18] = t;
    $[19] = t10;
  } else {
    t10 = $[19];
  }
  let t11;
  if ($[20] !== t) {
    t11 = t("global.email");
    $[20] = t;
    $[21] = t11;
  } else {
    t11 = $[21];
  }
  let t12;
  if ($[22] !== t11) {
    t12 = <div className="flex items-center gap-1.5">{t11}</div>;
    $[22] = t11;
    $[23] = t12;
  } else {
    t12 = $[23];
  }
  let t13;
  if ($[24] === Symbol.for("react.memo_cache_sentinel")) {
    t13 = e_0 => setTempState({
      email: e_0.target.value
    });
    $[24] = t13;
  } else {
    t13 = $[24];
  }
  let t14;
  if ($[25] !== errors.email || $[26] !== t12 || $[27] !== tempState.email) {
    t14 = <FormInput label={t12} required={true} type="email" value={tempState.email} onChange={t13} error={errors.email} />;
    $[25] = errors.email;
    $[26] = t12;
    $[27] = tempState.email;
    $[28] = t14;
  } else {
    t14 = $[28];
  }
  let t15;
  if ($[29] !== handleConfirm) {
    t15 = async e_1 => {
      e_1.preventDefault();
      await handleConfirm();
    };
    $[29] = handleConfirm;
    $[30] = t15;
  } else {
    t15 = $[30];
  }
  let t16;
  if ($[31] !== t) {
    t16 = t("global.save");
    $[31] = t;
    $[32] = t16;
  } else {
    t16 = $[32];
  }
  let t17;
  if ($[33] !== isFetching || $[34] !== t15 || $[35] !== t16) {
    t17 = <div className="flex justify-center gap-4"><PrimaryButton isFetching={isFetching} width="large" onClick={t15} type="submit">{t16}</PrimaryButton></div>;
    $[33] = isFetching;
    $[34] = t15;
    $[35] = t16;
    $[36] = t17;
  } else {
    t17 = $[36];
  }
  let t18;
  if ($[37] !== errors.common) {
    t18 = errors.common && <>{errors.common.map(_temp)}</>;
    $[37] = errors.common;
    $[38] = t18;
  } else {
    t18 = $[38];
  }
  let t19;
  if ($[39] !== t14 || $[40] !== t17 || $[41] !== t18) {
    t19 = <form className="flex flex-col gap-6 lg:gap-7">{t14}{t17}{t18}</form>;
    $[39] = t14;
    $[40] = t17;
    $[41] = t18;
    $[42] = t19;
  } else {
    t19 = $[42];
  }
  let t20;
  if ($[43] !== opened || $[44] !== t10 || $[45] !== t19) {
    t20 = <Modal opened={opened} onClose={onClose} title={t10} className="max-w-2xl">{t19}</Modal>;
    $[43] = opened;
    $[44] = t10;
    $[45] = t19;
    $[46] = t20;
  } else {
    t20 = $[46];
  }
  let t21;
  if ($[47] !== t20 || $[48] !== t9) {
    t21 = <>{t9}{t20}</>;
    $[47] = t20;
    $[48] = t9;
    $[49] = t21;
  } else {
    t21 = $[49];
  }
  return t21;
}
function _temp(error_0, index) {
  return <p className="text-red px-6 text-sm" key={index}>{error_0}</p>;
}
export default CreateSenderEmailAddressModal;